import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=d95f6d98&scoped=true&"
import script from "./PersonalInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=d95f6d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95f6d98",
  null
  
)

export default component.exports